/**
 * 动态气泡图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const dynamicBubbleValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'number', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'color', type: 'string', required: true },
    { field: 'group', type: ['string', 'date'], required: true },
    { field: 'size', type: 'number', required: false }
  ],
  businessRules: [
    {
      name: 'dynamic-bubble-minimum-data',
      validator: data => Array.isArray(data) && data.length >= 3,
      message: 'Dynamic bubble chart requires at least 3 data points',
      suggestion: 'Provide at least 3 data points for proper dynamic visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'dynamic-bubble-minimum-groups',
      validator: (data, layer) => {
        const groupField = layer.encoding?.group as string;
        if (!groupField || !Array.isArray(data)) {
          return true;
        }

        const groupValues = new Set(data.map(item => item[groupField] as string));
        return groupValues.size >= 2;
      },
      message: 'Dynamic bubble chart requires at least 2 different group values',
      suggestion: 'Ensure you have data spanning at least 2 different time periods or categories',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'dynamic-bubble-group-data-sufficiency',
      validator: (data, layer) => {
        const groupField = layer.encoding?.group as string;
        if (!groupField || !Array.isArray(data)) {
          return true;
        }

        const groupValues = new Set(data.map(item => item[groupField] as string));
        return Array.from(groupValues).every(group => {
          const dateData = data.filter(item => item[groupField] === group);
          return dateData.length >= 3;
        });
      },
      message: 'Each group in dynamic bubble chart should have at least 3 data points',
      suggestion:
        'Ensure each time period or category has sufficient data points for meaningful visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'dynamic-bubble-color-uniqueness',
      validator: (data, layer) => {
        const groupField = layer.encoding?.group as string;
        const colorField = layer.encoding?.color as string;
        if (!groupField || !colorField || !Array.isArray(data)) {
          return true;
        }

        const groupValues = new Set(data.map(item => item[groupField] as string));
        return Array.from(groupValues).every(group => {
          const dateData = data.filter(item => item[groupField] === group);
          const colorValues = dateData.map(item => item[colorField] as string);
          return colorValues.length === new Set(colorValues).size;
        });
      },
      message: 'Color field values must be unique within each group',
      suggestion: 'Ensure each data point has a unique color value within its group',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
